import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { RegisterComponent } from '../auth/register/register.component';
import { ForgotComponent } from '../auth/forgot/forgot.component';

import { LoginComponent } from './login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  // { path: 'login', component: LoginComponent, data: { title: marker('Login') } },
  // { path: 'register', component: RegisterComponent },
  // { path: 'forgot-password', component: ForgotComponent },
  // { path: 'reset-password', component: ResetPasswordComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRoutingModule {}
